// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: 'c039b3b784ce2e6ee44f7071bfc039e20c2ae8a6',
  buildTime: '2026-07-16T13:58:43.929Z',
} as const;
